"use client";

import { useEffect, useRef } from "react";
import "./LoadingAnimation.css";

export default function LoadingAnimation({ style }) {
  const boxRef = useRef(null); // Container-DIV
  const animRef = useRef(null); // Lottie-Instanz

  useEffect(() => {
    let cancelled = false; // 🏳️ Merker, ob Cleanup schon lief

    // Lottie erst nach Mount laden
    import("lottie-web/build/player/lottie_light").then((L) => {
      if (cancelled || animRef.current) return; // Effekt abgebrochen? -> nix tun

      animRef.current = L.loadAnimation({
        container: boxRef.current,
        renderer: "svg",
        loop: true,
        autoplay: true,
        path: "/lottie/hell.json",
      });
    });

    // 👉 Cleanup
    return () => {
      cancelled = true;
      animRef.current?.destroy();
      animRef.current = null;
    };
  }, []);

  return (
    <div className="loading-container" style={style} role="status" aria-label="Wird geladen">
      <div className="LoadingAnimation-wrapper">
        <div ref={boxRef} style={{ width: 250, height: 50 }} />
      </div>
    </div>
  );
}
